/**
 * @note Logiquement ce package étant prévu pour fonctionner avec WMU_Ajax il devrait se trouver dans wmu-wp-tools.
 */
class WMUAjaxQuery extends EventTarget {

	/**
	 * 
	 */
	constructor( args = {} )
	{
		const {
			url = '',
			action = '',
			nonce = '',
			pageCurrent = 0,
			queryArgs = {},
			requestArgs = {},
		} = args;

		const {
			posts_per_page = 10,
			post_type = 'post',
			post_status = 'publish',
			order = 'DESC',
			orderby = 'date',
		} = queryArgs;

		super();
		this.initArgs = args;
		
		this.url = url;
		this.action = action;
		this.nonce = nonce;
		this.pageCurrent = pageCurrent;
		
		this.queryArgs = {
			post_type: post_type,
			post_status: post_status,
			posts_per_page: posts_per_page,
			order: order,
			orderby: orderby,
			...queryArgs
		};

		this.requestArgs = { ...requestArgs };

		this._xhr = null;
		this.items = [];
		this.itemsTotal = 0;
		this.itemsPerPage = posts_per_page;
		this.queryInProgress = false;

		this.onProgress = this.onProgress.bind( this );
		this.onLoad = this.onLoad.bind( this );
		this.onError = this.onError.bind( this );
		this.onAbort = this.onAbort.bind( this );
	}

	/**
	 * 
	 */
	get xhr()
	{
		if ( null === this._xhr )
		{
			this._xhr = new XMLHttpRequest();
			
			this._xhr.addEventListener( 'progress', this.onProgress, false );
			this._xhr.addEventListener( 'load', this.onLoad, false );
			this._xhr.addEventListener( 'error', this.onError, false );
			this._xhr.addEventListener( 'abort', this.onAbort, false );
		}

		return this._xhr;
	}

	/**
	 * 
	 */
	get pageTotal()
	{
		return Math.ceil( this.itemsTotal / this.itemsPerPage );
	}

	/**
	 * 
	 */
	clear()
	{
		// console.log( "AjaxQuery.clear" );

		this.items = [];

		if ( this.queryInProgress )
		{
			this.endQuery();
		}
	}

	/**
	 * 
	 */
	addItem( item )
	{
		// NOTE: Il faudra voir si on ne check pas les doublons
		this.dispatchEvent( new CustomEvent( 'addItem', { detail: item } ) );
		this.items.push( item );
		this.dispatchEvent( new CustomEvent( 'itemAdded', { detail: item } ) );
	}

	/**
	 * 
	 */
	addItems( items )
	{
		this.dispatchEvent( new CustomEvent( 'addItems', { detail: items } ) );

		if ( items && items.length > 0 )
		{
			items.forEach( ( item ) => this.addItem( item ) );
		}

		this.dispatchEvent( new CustomEvent( 'itemsAdded', { detail: items } ) );
	}

	/**
	 * 
	 */
	resetItems()
	{
		if ( this.items && this.items.length > 0 )
		{
			this.items = [];
		}
	}

	/**
	 * 
	 */
	hasPageToLoad()
	{
		return ( 0 === this.itemsTotal || this.pageCurrent < this.pageTotal );
	}

	/**
	 * 
	 */
	startQuery( page )
	{
		// console.log( 'AjaxQuery.startQuery', `page: ${page}`, `pageCurrent: ${this.pageCurrent}` );

		this.xhr.open( 'POST', this.url );
		this.xhr.send( this.formatQueryData( page ) );
		this.queryInProgress = true;
	}

	/**
	 * 
	 */
	endQuery()
	{
		// console.log( 'AjaxQuery.endQuery', this._xhr );

		if ( null !== this._xhr )
		{
			this._xhr.removeEventListener( 'progress', this.onProgress );
			this._xhr.removeEventListener( 'load', this.onLoad );
			this._xhr.removeEventListener( 'error', this.onError );
			this._xhr.removeEventListener( 'abort', this.onAbort );
		}

		this._xhr = null;
		this.queryInProgress = false;
	}

	/**
	 * 
	 */
	abortQuery()
	{
		// console.log( 'AjaxQuery.abortQuery', this._xhr );

		if ( null !== this._xhr )
		{
			this._xhr.abort();
			this.endQuery();
		}
	}
	
	/**
	 * Remove all items, abort current query if any and reset all paramaters to let
	 * start a new process from scratch.
	 */
	resetQuery()
	{
		// console.log( 'AjaxQuery.resetQuery', this._xhr );

		this.abortQuery();
		this.resetItems();

		this.pageCurrent = 0;
		this.itemsTotal = 0;

		this.dispatchEvent( new CustomEvent( 'resetQuery' ) );
	}

	/**
	 * 
	 */
	querySuccess( data )
	{
		this.itemsTotal = data.max_items;
		this.dispatchEvent( new CustomEvent( 'querySuccess', { detail: data } ) );
		this.addItems( data.items );
	}

	/**
	 * 
	 */
	queryError( response )
	{
		this.dispatchEvent( new CustomEvent( 'queryError', { detail: response } ) );
	}

	/**
	 * 
	 */
	getQueryData( page )
	{
		return {
			action: this.action,
			_ajax_nonce: this.nonce,
			query_args: {
				...this.queryArgs,
				paged: page
			},
			...this.requestArgs,
		};
	}

	/**
	 * 
	 */
	formatQueryData( page )
	{
		const formData = new FormData();
		const data = this.getQueryData( page );

		for ( let key in data )
		{
			if ( 'query_args' === key )
			{
				formData.append( key, JSON.stringify( data[ key ] ) );
			}
			else
			{
				formData.append( key, data[ key ] );
			}
		}

		return formData;
	}

	/**
	 * 
	 */
	nextPage()
	{
		// console.log( "AjaxQuery.nextPage", `pageCurrent: ${this.pageCurrent}` );

		if ( ! this.url || this.queryInProgress || ! this.hasPageToLoad() )
		{
			// console.log( "AjaxQuery.nextPage - Aborting request" );
			return false;
		}

		this.pageCurrent++;
		this.startQuery( this.pageCurrent );
		return true;
	}

	/**
	 * 
	 */
	onProgress( event )
	{
		// Dispatch directement cet event ? Faire plutôt un custom event avec un param originalEvent ?
	}

	/**
	 * 
	 */
	onLoad( event )
	{
		// Dispatch directement cet event ? Faire plutôt un custom event avec un param originalEvent ?
		let response = null;

		if ( this._xhr.response )
		{
			response = JSON.parse( this._xhr.response );
		}

		// Query success
		if ( response && true === response.success )
		{
			this.querySuccess( response.data );
		}

		// Query error
		else
		{
			this.queryError( response );
		}
		
		this.endQuery();
	}

	/**
	 * 
	 */
	onError( event )
	{
		// Dispatch directement cet event ? Faire plutôt un custom event avec un param originalEvent ?
		let response = null;

		if ( this._xhr.response )
		{
			response = JSON.parse( this._xhr.response );
		}

		this.queryError( response );
		this.endQuery();
	}

	/**
	 * 
	 */
	onAbort( event )
	{
		// Dispatch directement cet event ? Faire plutôt un custom event avec un param originalEvent ?
		this.endQuery();
	}

}

export default WMUAjaxQuery;